<template>
  <footer class="site-footer">
    <div class="footer-container container">
      <!-- 主体区域 -->
      <div class="footer-main">
        <!-- 品牌信息 -->
        <div class="footer-brand">
          <router-link to="/" class="footer-logo">
            <img
              class="footer-logo-image"
              :src="officialLogo"
              alt="Archeaux Studio 元基智能"
            />
          </router-link>
          <p class="footer-desc">
            AI情感陪伴机器人，融合法式优雅与东方哲学，<br />
            用科技传递温暖，让每个生命都被温柔以待。
          </p>
          <!-- 社交图标 -->
          <div class="social-icons" v-if="socialIcons.length > 0">
            <a
              v-for="(icon, index) in socialIcons"
              :key="index"
              :href="icon.url"
              :title="icon.title"
              class="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img v-if="icon.image" :src="icon.image" :alt="icon.title" />
              <i v-else :class="icon.iconClass"></i>
            </a>
          </div>
          <!-- 默认社交图标 -->
          <div class="social-icons" v-else>
            <a href="#" class="social-icon" title="微信">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm3.2 4.127c-3.997 0-7.242 2.697-7.242 6.03 0 3.334 3.245 6.03 7.242 6.03.726 0 1.424-.104 2.076-.282a.624.624 0 01.516.07l1.37.8a.234.234 0 00.12.04.212.212 0 00.209-.213c0-.052-.02-.103-.034-.154l-.281-1.064a.426.426 0 01.153-.478c1.378-1.014 2.27-2.548 2.27-4.249 0-3.333-3.245-6.03-7.242-6.03h-.157zm-2.347 3.395c.463 0 .838.381.838.85a.844.844 0 01-.838.85.844.844 0 01-.838-.85c0-.469.376-.85.838-.85zm4.693 0c.463 0 .838.381.838.85a.844.844 0 01-.838.85.844.844 0 01-.838-.85c0-.469.376-.85.838-.85z"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="微博">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10.098 20.323c-3.977.391-7.414-1.406-7.672-4.02-.259-2.609 2.759-5.047 6.74-5.441 3.979-.394 7.413 1.404 7.671 4.018.259 2.6-2.759 5.049-6.739 5.443zm-1.405-7.498c-2.623.268-4.586 1.949-4.387 3.756.199 1.808 2.473 3.012 5.096 2.744 2.623-.268 4.586-1.949 4.387-3.756-.199-1.808-2.473-3.012-5.096-2.744zM20.196 9.4a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296a5.07 5.07 0 00-1.958-.478c-.233-.025-.439-.189-.439-.424s.206-.399.439-.424a5.07 5.07 0 001.958-.478c.658-.293 1.038-.778 1.038-1.296 0-.518-.38-1.003-1.038-1.296"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="抖音">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.16V11.7a4.83 4.83 0 01-3.77-1.24V6.69h3.77z"/>
              </svg>
            </a>
            <a href="#" class="social-icon" title="小红书">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.5 13.5h-9a1 1 0 01-1-1v-7a1 1 0 011-1h9a1 1 0 011 1v7a1 1 0 01-1 1zm-7-6.5v5h2v-5h-2zm3 0v5h2v-5h-2z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- 底部链接 -->
        <div class="footer-links" v-if="footerLinks.length > 0">
          <div
            v-for="(group, index) in footerLinkGroups"
            :key="index"
            class="footer-link-group"
          >
            <h4 class="link-group-title">{{ group.title }}</h4>
            <ul class="link-list">
              <li v-for="link in group.children" :key="link.id">
                <router-link :to="link.url" class="footer-link">{{ link.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 默认底部链接 -->
        <div class="footer-links" v-else>
          <div class="footer-link-group">
            <h4 class="link-group-title">产品系列</h4>
            <ul class="link-list">
              <li><router-link to="/products/children" class="footer-link">小元基</router-link></li>
              <li><router-link to="/products/youth" class="footer-link">Élément</router-link></li>
              <li><router-link to="/products/elderly" class="footer-link">守望者</router-link></li>
            </ul>
          </div>
          <div class="footer-link-group">
            <h4 class="link-group-title">关于我们</h4>
            <ul class="link-list">
              <li><router-link to="/about" class="footer-link">公司简介</router-link></li>
              <li><router-link to="/news" class="footer-link">新闻动态</router-link></li>
              <li><router-link to="/about#contact" class="footer-link">联系我们</router-link></li>
            </ul>
          </div>
          <div class="footer-link-group">
            <h4 class="link-group-title">商务合作</h4>
            <ul class="link-list">
              <li><router-link to="/cooperation" class="footer-link">渠道代理</router-link></li>
              <li><router-link to="/cooperation" class="footer-link">品牌联名</router-link></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="footer-bottom">
        <p class="copyright">
          &copy; {{ currentYear }} Archeaux Studio. All Rights Reserved.
        </p>
        <p class="icp" v-if="companyAddress">{{ companyAddress }}</p>
        <a
          class="icp icp-link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >{{ displayIcpNumber }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import officialLogo from '@/assets/images/logo/archeaux-logo-full.webp'

const DEFAULT_ICP_NUMBER = '粤ICP备2026098392号-1'
const DEFAULT_COMPANY_ADDRESS = '深圳市龙华区环智中心A座4楼'

export default {
  name: 'SiteFooter',
  data() {
    return {
      officialLogo,
      currentYear: new Date().getFullYear(),
      companyAddress: DEFAULT_COMPANY_ADDRESS,
      icpNumber: ''
    }
  },
  computed: {
    ...mapGetters('button', ['footerLinkList', 'socialIconList']),
    socialIcons() {
      return this.socialIconList || []
    },
    footerLinks() {
      return this.footerLinkList || []
    },
    displayIcpNumber() {
      return this.icpNumber || DEFAULT_ICP_NUMBER
    },
    footerLinkGroups() {
      const groups = {}
      this.footerLinks.forEach(link => {
        const groupName = link.title || link.group || ''
        // Skip if this link has a parent (it's a child)
        if (link.parentId && link.parentId > 0) return
        if (!groups[groupName]) {
          groups[groupName] = { title: groupName, children: [] }
        }
        // Find children
        const children = this.footerLinks.filter(l => l.parentId === link.id)
        groups[groupName].children = children.map(c => ({ id: c.id, title: c.title, url: c.url }))
      })
      return Object.values(groups).filter(g => g.children.length > 0)
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  position: relative;
  background:
    linear-gradient(180deg, #eee5d8 0%, #e4d7c5 100%);
  color: $color-text-secondary;
  padding-top: $spacing-4xl;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
      linear-gradient(90deg, rgba($color-primary, 0.04) 0 1px, transparent 1px),
      linear-gradient(180deg, rgba(255, 255, 255, 0.32), transparent 48%);
    background-size: 128px 100%, 100% 100%;
    opacity: 0.45;
  }
}

.footer-container {
  position: relative;
  z-index: 1;
  max-width: $container-max-width;
  margin: 0 auto;
  padding: 0 $container-padding;
}

.footer-main {
  display: grid;
  grid-template-columns: 1.5fr 2fr;
  gap: $spacing-4xl;
  padding-bottom: $spacing-3xl;
  border-bottom: 1px solid rgba($color-primary, 0.12);

  @include respond-to('lg') {
    grid-template-columns: 1fr;
    gap: $spacing-2xl;
  }
}

// 品牌信息
.footer-brand {
  .footer-logo {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: $spacing-lg;
    padding: $spacing-md $spacing-lg;
    border-radius: $radius-lg;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba($color-primary, 0.12);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.62);
  }

  .footer-logo-image {
    width: 148px;
    height: auto;
    object-fit: contain;
    opacity: 0.92;
  }

  .footer-desc {
    font-size: $font-size-sm;
    line-height: $line-height-loose;
    color: $color-text-secondary;
    margin-bottom: $spacing-xl;
  }
}

// 社交图标
.social-icons {
  display: flex;
  gap: $spacing-md;
}

.social-icon {
  width: 40px;
  height: 40px;
  border-radius: $radius-full;
  background-color: rgba(255, 255, 255, 0.48);
  border: 1px solid rgba($color-primary, 0.14);
  @include flex-center;
  color: $color-primary;
  transition: all $transition-base;

  &:hover {
    background-color: rgba($color-secondary, 0.92);
    color: $color-text-white;
    transform: translateY(-2px);
  }

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}

// 底部链接
.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: $spacing-xl;

  @include respond-to('md') {
    grid-template-columns: repeat(2, 1fr);
  }

  @include mobile-only {
    grid-template-columns: 1fr;
    gap: $spacing-lg;
  }
}

.footer-link-group {
  .link-group-title {
    font-size: $font-size-md;
    font-weight: $font-weight-semibold;
    color: $color-text;
    margin-bottom: $spacing-lg;
    &::after {
      content: '';
      display: block;
      width: 28px;
      height: 1px;
      margin-top: $spacing-sm;
      background: linear-gradient(90deg, $color-secondary, transparent);
    }
  }
}

.link-list {
  @include flex-column;
  gap: $spacing-sm;
}

.footer-link {
  font-size: $font-size-sm;
  color: $color-text-secondary;
  transition: all $transition-fast;
  padding: $spacing-xs 0;

  &:hover {
    color: $color-secondary;
    padding-left: $spacing-sm;
  }
}

// 底部版权
.footer-bottom {
  padding: $spacing-xl 0;
  text-align: center;

  .copyright {
    font-size: $font-size-sm;
    color: rgba($color-text, 0.56);
    margin-bottom: $spacing-xs;
  }

  .icp {
    display: block;
    font-size: $font-size-xs;
    color: rgba($color-text, 0.46);
  }

  .icp-link {
    width: fit-content;
    margin: $spacing-xs auto 0;
    transition: color $transition-fast;

    &:hover {
      color: rgba($color-secondary, 0.9);
    }
  }
}
</style>
